export default {
  dealerUsers: [],
  dealerUser: {},
};
